/*
 * AUTO OBRAZY — V298 košík.
 *
 * 1. Tlačidlo do pokladne hovorí, čo treba urobiť: „Vybrať dopravu ↑“ /
 *    „Pokračovať k platbe“. Zamykanie a kontrolu Z-BOXu ďalej robí
 *    ao-cart-benefits.js (AOGlobeDeliveryGuard) — tu len čítame jeho stav.
 * 2. (V299: rýchla platba v košíku nie je.)
 * 3. Rozpis sumy: doprava podľa vybraného spôsobu, SPOLU vrátane dopravy.
 * 4. „Pridaj 2. tričko“ — pridanie na jedno ťuknutie bez odchodu z košíka.
 * 5. Udalosti pre Microsoft Clarity (lievik košíka).
 */
(function () {
  'use strict';
  if (window.__aoCartV298) return;
  window.__aoCartV298 = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var base = root.replace(/\/$/, '');
  var CTA_SELECTOR = '.ao-globe-checkout-button, [data-ao-checkout], #checkout, button[name="checkout"]';

  function money(cents) {
    if (window.AOMoney && window.AOMoney.format) return window.AOMoney.format(cents);
    return (Number(cents || 0) / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* ---------- Clarity ---------- */
  var sent = {};
  function clarityEvent(name, once) {
    if (once && sent[name]) return;
    sent[name] = true;
    try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch (e) {}
    try { if (window.AOAnalytics && window.AOAnalytics.track) window.AOAnalytics.track(name, {}); } catch (e) {}
  }
  function claritySet(key, value) {
    try { if (typeof window.clarity === 'function') window.clarity('set', key, String(value)); } catch (e) {}
  }

  /* ---------- stav dopravy ---------- */
  /* Stav čítame z toho, čo už vykresľuje AOGlobeDeliveryGuard
     (ao-cart-benefits.js): trieda modulu a text štítka. Guard sa nemení. */
  function currentState() {
    var module = null;
    var modules = document.querySelectorAll('[data-ao-globe-module]');
    for (var i = 0; i < modules.length; i++) {
      if (modules[i].offsetParent !== null || modules[i].getClientRects().length) { module = modules[i]; break; }
    }
    if (!module) module = modules[0] || null;
    var resolved = Boolean(module && module.classList.contains('is-delivery-resolved'));
    var pill = module && module.querySelector('.ao-globe-brand__pill');
    var text = pill ? String(pill.textContent || '').toUpperCase() : '';
    var mode = '';
    if (resolved) mode = text.indexOf('ADRES') !== -1 ? 'home' : 'pickup';
    if (!mode) {
      var attrs = window.AOCartAttributes || {};
      var d = String(attrs.Doprava || '');
      if (d === 'Kuriér na adresu') mode = 'home';
      else if (d === 'Výdajné miesto') mode = 'pickup';
    }
    return { ok: resolved, resolved: resolved, mode: mode };
  }

  var lastKey = '';
  function emitState() {
    var s = currentState();
    var key = s.resolved + ':' + s.mode;
    if (key === lastKey) return;
    lastKey = key;
    if (s.resolved) {
      clarityEvent('cart_delivery_selected', true);
      claritySet('ao_delivery', s.mode || 'unknown');
    }
  }

  function isLocked(button) {
    return button.getAttribute('data-ao-globe-locked') === 'true' || button.classList.contains('is-globe-locked');
  }

  function paintButtons() {
    document.querySelectorAll(CTA_SELECTOR).forEach(function (button) {
      if (!(button instanceof HTMLElement)) return;
      var label = button.querySelector('[data-ao-cta-label]');
      var text = isLocked(button) ? 'Vybrať dopravu ↑' : 'Pokračovať k platbe';
      /* V304: v tlačidle aj suma — riadok SPOLU vyššie nemusí byť vidieť. */
      if (!isLocked(button)) {
        var scope = button.closest('.cart-drawer, .ao-cart-page, form, body') || document;
        var grandEl = scope.querySelector('[data-ao-grand]') || document.querySelector('[data-ao-grand]');
        var sum = grandEl ? String(grandEl.textContent || '').trim() : '';
        if (sum) text += ' · ' + sum;
      }
      if (label) {
        if (label.textContent !== text) label.textContent = text;
      }
      /* V299: rýchla platba (Apple Pay / Google Pay) sa v košíku už neodkrýva. */
    });
  }

  function paintTotals() {
    var state = currentState();
    document.querySelectorAll('[data-ao-cart-totals]').forEach(function (box) {
      var goods = Number(box.dataset.goods) || 0;
      var free = box.dataset.free === 'true';
      /* V312: doprava sa do SPOLU pripočíta až po reálnom výbere (dlaždica
         je vyriešená). Starý uložený atribút z minulej návštevy sa nepočíta. */
      var mode = state.resolved ? state.mode : '';
      var ship = -1;
      if (free) ship = 0;
      else if (mode === 'home') ship = Number(box.dataset.home) || 0;
      else if (mode === 'pickup') ship = Number(box.dataset.pickup) || 0;

      var line = box.querySelector('[data-ao-ship-line]');
      if (line) {
        var html;
        if (free) html = '<b class="ao-totals__free">ZADARMO</b>';
        else if (ship >= 0) html = money(ship);
        else html = '<em>od ' + money(Number(box.dataset.pickup) || 0) + '</em>';
        /* V305: porovnávame podľa uloženej hodnoty — na /cs/ sa text v DOM prekladá. */
        if (line.getAttribute('data-ao-html') !== html) { line.setAttribute('data-ao-html', html); line.innerHTML = html; }
      }
      var grand = box.querySelector('[data-ao-grand]');
      if (grand) {
        var g = money(goods + (ship > 0 ? ship : 0));
        if (grand.textContent !== g) grand.textContent = g;
      }
      var hint = box.querySelector('[data-ao-grand-hint]');
      if (hint) hint.hidden = ship >= 0;
    });
  }

  /* V299: pri „Doručenie domov“ jedna veta, že adresa sa zadáva až v pokladni.
     Dlaždicu kreslí appka Globe, preto len pridáme atribút a text kreslí CSS
     (::before), aby sa nezmenil textContent, z ktorého guard číta voľbu. */
  var HOME_NOTE = 'Adresu zadáš v pokladni';
  var HOME_RE = /doručenie domov|doručenie na adresu|na adresu|home delivery|kuriér|courier|doručení domů|doručení na adresu|kurýr/;
  function markHomeTiles() {
    document.querySelectorAll('[data-ao-globe-module]').forEach(function (module) {
      var done = false;
      module.querySelectorAll('[data-ao-rate-label], [data-delivery-method]').forEach(function (tile) {
        if (done) return;
        var text = String(tile.textContent || '').toLowerCase();
        if (!HOME_RE.test(text)) return;
        if (tile.getBoundingClientRect().width < 70) return;
        if (tile.getAttribute('data-ao-home-note') !== HOME_NOTE) tile.setAttribute('data-ao-home-note', HOME_NOTE);
        done = true;
      });
    });
  }

  /* V300: pri bežnom tričku v bočnom košíku netreba rozbaľovať „Detaily
     personalizácie“ kvôli jednému údaju (napr. „Slovenský text“). Krátke
     vlastnosti bez odkazov sa pridajú priamo k variantu: Biela / L / Slovenský text. */
  function inlineShortProperties() {
    document.querySelectorAll('.cart-drawer details.ao-cart-properties-disclosure').forEach(function (details) {
      if (details.dataset.aoInlineChecked === 'true') return;
      details.dataset.aoInlineChecked = 'true';
      var dds = Array.prototype.slice.call(details.querySelectorAll('.cart-items__property dd'));
      if (!dds.length || dds.length > 2) return;
      var ok = dds.every(function (dd) {
        var t = String(dd.textContent || '').trim();
        return t && t.length <= 30 && !dd.querySelector('a');
      });
      if (!ok) return;
      var wrapper = details.closest('.cart-items__variants-wrapper');
      if (!wrapper) return;
      var list = wrapper.querySelector('.cart-items__variants');
      if (!list) {
        list = document.createElement('dl');
        list.className = 'cart-items__variants';
        wrapper.insertBefore(list, wrapper.firstChild);
      }
      dds.forEach(function (dd) {
        var row = document.createElement('div');
        row.className = 'cart-items__variant ao-inline-prop';
        var out = document.createElement('dd');
        out.textContent = String(dd.textContent || '').trim();
        row.appendChild(out);
        list.appendChild(row);
      });
      details.hidden = true;
    });
  }

  /* V300: bodky pod fotkami produktu na kartách (katalóg, homepage) —
     koľko fotiek, toľko bodiek, svieti tá, ktorá je práve vidieť. */
  function cardDots() {
    document.querySelectorAll('[data-ao-card-slides], [data-ao4-slides]').forEach(function (track) {
      if (track.__aoDots) return;
      var slides = Array.prototype.filter.call(track.children, function (c) { return c.nodeType === 1; });
      if (slides.length < 2) return;
      var host = track.parentElement;
      if (!host) return;
      track.__aoDots = true;
      var dots = document.createElement('div');
      dots.className = 'ao-dots';
      dots.setAttribute('aria-hidden', 'true');
      slides.forEach(function (_, i) {
        var d = document.createElement('span');
        if (i === 0) d.className = 'is-on';
        dots.appendChild(d);
      });
      host.appendChild(dots);
      var raf = 0;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('is-on', k === i); });
        });
      }, { passive: true });
    });
  }


  /* ---------- V302: doprava sa po výbere zbalí ---------- */
  /* Widget Globe ostáva v DOM (strážca dopravy z neho číta), CSS ho len
     vizuálne zbalí a ukáže jeden riadok s výberom a tlačidlom Zmeniť. */
  var shipOpen = {};
  var shipPoll = 0;
  function shipInfo(module) {
    var pill = module.querySelector('.ao-globe-brand__pill');
    var p = pill ? String(pill.textContent || '').toUpperCase() : '';
    var g = window.AOGlobeGuard || null;
    if (p.indexOf('ADRES') !== -1 || (g && g.mode === 'home')) return { kind: 'Doručenie na adresu', detail: 'Adresu zadáš v pokladni' };
    /* V302b: názov miesta berieme z atribútov košíka, ktoré zapisuje Globe
       (PickupPointName / PickupPointCity) — text widgetu je neupratený. */
    var attrs = window.AOCartAttributes || {};
    var name = String(attrs.PickupPointName || '').trim();
    var kind = /z[\s-]?box/i.test(name) || p.indexOf('Z-BOX') !== -1 ? 'Z-BOX' : 'Výdajné miesto';
    var detail = name.replace(/^z[\s-]?box\s*[,:-]?\s*/i, '');
    if (!detail && attrs.PickupPointCity) detail = String(attrs.PickupPointAddress || '') + (attrs.PickupPointAddress ? ', ' : '') + String(attrs.PickupPointCity);
    detail = detail.replace(/\s+/g, ' ').trim();
    if (detail.length > 70) detail = detail.slice(0, 68).trim() + '…';
    if (!detail) refreshCartAttrs();
    return { kind: kind, detail: detail };
  }
  var attrsFetching = false, attrsFetchedAt = 0;
  function refreshCartAttrs() {
    if (attrsFetching || Date.now() - attrsFetchedAt < 4000) return;
    attrsFetching = true;
    fetch(base + '/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (cart && cart.attributes) window.AOCartAttributes = Object.assign({}, window.AOCartAttributes || {}, cart.attributes);
      })
      .catch(function () {})
      .then(function () { attrsFetching = false; attrsFetchedAt = Date.now(); paint(); });
  }
  function paintShip() {
    document.querySelectorAll('[data-ao-globe-module]').forEach(function (module) {
      var ctx = module.getAttribute('data-ao-globe-module') || 'x';
      var resolved = module.classList.contains('is-delivery-resolved');
      var done = null;
      for (var i = 0; i < module.children.length; i++) {
        if (module.children[i].classList.contains('ao-ship-done')) { done = module.children[i]; break; }
      }
      if (!resolved) {
        if (module.classList.contains('is-ship-collapsed')) module.classList.remove('is-ship-collapsed');
        if (done && !done.hidden) done.hidden = true;
        return;
      }
      var info = shipInfo(module);
      var sig = info.kind + '|' + info.detail;
      var open = shipOpen[ctx];
      /* Po „Zmeniť“ sa zbalí znova, až keď sa výber naozaj zmení. */
      if (open && open.sig !== sig && !open.timer) {
        open.timer = window.setTimeout(function () { delete shipOpen[ctx]; paint(); }, 700);
      }
      if (!done) {
        done = document.createElement('div');
        done.className = 'ao-ship-done';
        done.innerHTML = '<span class="ao-ship-done__ok" aria-hidden="true">✓</span>'
          + '<span class="ao-ship-done__txt"><b></b><small></small></span>'
          + '<button type="button" class="ao-ship-done__edit" data-ao-ship-edit>Zmeniť</button>';
        module.insertBefore(done, module.firstChild);
      }
      if (done.hidden) done.hidden = false;
      var b = done.querySelector('b'), sm = done.querySelector('small'), btn = done.querySelector('[data-ao-ship-edit]');
      if (b.textContent !== info.kind) b.textContent = info.kind;
      if (sm.textContent !== info.detail) sm.textContent = info.detail;
      var label = shipOpen[ctx] ? 'Zbaliť' : 'Zmeniť';
      if (btn.textContent !== label) btn.textContent = label;
      var collapse = !shipOpen[ctx];
      if (module.classList.contains('is-ship-collapsed') !== collapse) module.classList.toggle('is-ship-collapsed', collapse);
    });
  }
  document.addEventListener('click', function (event) {
    var btn = event.target instanceof Element ? event.target.closest('[data-ao-ship-edit]') : null;
    if (!btn) return;
    event.preventDefault();
    var module = btn.closest('[data-ao-globe-module]');
    if (!module) return;
    var ctx = module.getAttribute('data-ao-globe-module') || 'x';
    if (shipOpen[ctx]) { window.clearTimeout(shipOpen[ctx].timer); delete shipOpen[ctx]; }
    else { var info = shipInfo(module); shipOpen[ctx] = { sig: info.kind + '|' + info.detail, timer: 0 }; }
    /* Widget môže zmeniť len text bez nových uzlov — kým je otvorený, kontrolujeme aj časovačom. */
    window.clearInterval(shipPoll);
    shipPoll = 0;
    if (Object.keys(shipOpen).length) shipPoll = window.setInterval(function () {
      if (!Object.keys(shipOpen).length) { window.clearInterval(shipPoll); shipPoll = 0; return; }
      attrsFetchedAt = 0;
      refreshCartAttrs();
    }, 700);
    paint();
    clarityEvent('cart_delivery_change_click');
  });

  /* ---------- V302: nálepky v košíku — ťuk na náhľad ---------- */
  /* Otvorí výber balíka; po zvolení balíka sa ťuknutý motív pridá sám. */
  /* scrollIntoView by posunul aj skryté (overflow:hidden) obaly košíka —
     potom sa zoznam „zasekne“. Posúvame len samotný zoznam. */
  function scrollInDrawer(el) {
    var box = el && el.closest('[data-cart-drawer-scroll]');
    if (!box) return;
    var r = el.getBoundingClientRect(), b = box.getBoundingClientRect();
    var delta = 0;
    if (r.bottom > b.bottom - 12) delta = r.bottom - b.bottom + 12;
    else if (r.top < b.top + 12) delta = r.top - b.top - 12;
    if (delta) box.scrollBy({ top: delta, behavior: 'smooth' });
  }
  var sbPending = null;
  function sbApplyPending() {
    if (!sbPending) return false;
    var r = sbPending.root;
    var mix = r.querySelector('[data-sb-mix]');
    if (!mix || mix.hidden) return false;
    var name = sbPending.name;
    sbPending = null;
    var cards = r.querySelectorAll('[data-sb-card]');
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].getAttribute('data-sticker-name') === name) {
        var plus = cards[i].querySelector('[data-sb-plus]');
        if (plus && !plus.disabled) plus.click();
        scrollInDrawer(cards[i]);
        break;
      }
    }
    return true;
  }
  document.addEventListener('click', function (event) {
    var t = event.target instanceof Element ? event.target : null;
    if (!t) return;
    var pick = t.closest('[data-sb-pick]');
    if (pick) {
      event.preventDefault();
      var r = pick.closest('[data-ao-sticker-bundle]');
      if (!r) return;
      r.querySelectorAll('[data-sb-pick]').forEach(function (b) { b.classList.toggle('is-picked', b === pick); });
      sbPending = { root: r, name: pick.getAttribute('data-sb-pick') };
      var toggle = r.querySelector('[data-sb-toggle]');
      if (toggle && toggle.getAttribute('aria-expanded') !== 'true') toggle.click();
      clarityEvent('cart_sticker_thumb_click');
      window.setTimeout(function () {
        if (sbApplyPending()) return;
        var packs = r.querySelector('.ao-sb__packs');
        if (packs) scrollInDrawer(packs);
      }, 80);
      return;
    }
    if (sbPending && t.closest('[data-sb-pack]')) window.setTimeout(sbApplyPending, 40);
  });

  var frame = 0;
  function paint() {
    if (frame) return;
    frame = window.requestAnimationFrame(function () {
      frame = 0;
      paintTotals();
      paintButtons();
      markHomeTiles();
      inlineShortProperties();
      cardDots();
      /* V303: zbaľovanie dopravy vypnuté na želanie — widget Packeta je stále celý rozbalený. */
      emitState();
    });
  }


  /* Guard mení atribúty tlačidla; drawer sa po každej zmene košíka
     prekreslí. Sledujeme oboje, prácu zbierame do jedného rámca. */
  var mo = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var r = records[i];
      if (r.type === 'attributes') {
        var el = r.target;
        if (r.attributeName !== 'class' || (el.matches && el.matches('[data-ao-globe-module], ' + CTA_SELECTOR))) { paint(); return; }
        continue;
      }
      if (r.addedNodes && r.addedNodes.length) { paint(); return; }
    }
  });
  function observe() {
    mo.observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['data-ao-globe-locked', 'aria-disabled', 'class']
    });
  }

  /* V302b: obaly košíka (dialog, vnútro, zoznam položiek) majú overflow:hidden
     a nesmú byť nikdy posunuté. Keď ich posunie scrollIntoView alebo fokus,
     spodok košíka „zamrzne“ — vrátime ich na 0. */
  function unstickWrappers(dialog) {
    var nodes = [dialog].concat(Array.prototype.slice.call(dialog.querySelectorAll('.cart-drawer__inner, cart-items-component, .cart-items-component')));
    nodes.forEach(function (n) {
      if (n && !n.hasAttribute('data-cart-drawer-scroll') && (n.scrollTop || n.scrollLeft)) { n.scrollTop = 0; n.scrollLeft = 0; }
    });
  }
  document.addEventListener('scroll', function (event) {
    var n = event.target;
    if (!(n instanceof Element) || n.hasAttribute('data-cart-drawer-scroll')) return;
    if (n.matches('.cart-drawer__dialog, .cart-drawer__inner, cart-items-component') && n.closest('.cart-drawer')) unstickWrappers(n.closest('.cart-drawer__dialog') || n);
  }, true);

  /* V301: na iPhone sa košík po doscrollovaní na koniec „zasekol“ — ďalší
     ťah išiel na stránku pod ním a nič nereagovalo. Pri dotyku posunieme
     zoznam o 1 px od okraja, takže ťah ostane vždy v košíku. */
  document.addEventListener('touchstart', function (event) {
    var t = event.target instanceof Element ? event.target : null;
    var dialog = t && t.closest('.cart-drawer__dialog');
    if (dialog) unstickWrappers(dialog);
    var box = t && t.closest('[data-cart-drawer-scroll]');
    if (!box) return;
    var max = box.scrollHeight - box.clientHeight;
    if (max <= 0) return;
    /* V302b: scrollTop býva na iPhone desatinné (napr. 1233.5 pri max 1234) —
       preto tolerancia 1 px a posun o 2 px. */
    if (box.scrollTop <= 1) box.scrollTop = 2;
    else if (box.scrollTop >= max - 1) box.scrollTop = max - 2;
  }, { passive: true, capture: true });
  /* Ťahy mimo zoznamu (hlavička, spodná lišta) nesmú posúvať stránku pod košíkom. */
  document.addEventListener('touchmove', function (event) {
    if (!document.documentElement.classList.contains('ao-cart-drawer-open')) return;
    var t = event.target instanceof Element ? event.target : null;
    if (!t || !t.closest('.cart-drawer__dialog')) return;
    if (t.closest('[data-cart-drawer-scroll]')) return;
    var el = t;
    while (el && !el.classList.contains('cart-drawer__dialog')) {
      var cs = window.getComputedStyle(el);
      if ((/(auto|scroll)/.test(cs.overflowY) && el.scrollHeight > el.clientHeight) || (/(auto|scroll)/.test(cs.overflowX) && el.scrollWidth > el.clientWidth)) return;
      el = el.parentElement;
    }
    if (event.cancelable) event.preventDefault();
  }, { passive: false, capture: true });

  /* ---------- lievik pre Clarity ---------- */
  document.addEventListener('click', function (event) {
    var t = event.target instanceof Element ? event.target : null;
    if (!t) return;
    if (t.closest('[data-ao-globe-module]')) clarityEvent('cart_delivery_interact', true);
    var cta = t.closest(CTA_SELECTOR);
    if (cta) {
      if (isLocked(cta)) clarityEvent('cart_checkout_locked_click');
      else clarityEvent('cart_checkout_click');
    }
    if (t.closest('[data-ao-express]')) clarityEvent('cart_express_click');
    if (t.closest('cart-drawer-component [on\\:click="/open"], [data-testid="cart-drawer-trigger"]')) clarityEvent('cart_open');
  }, true);

  /* ---------- 2. tričko ---------- */
  function sectionData() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      var id = el.dataset.sectionId;
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    if (!ids.length) return {};
    return { sections: ids.join(','), sections_url: window.location.pathname };
  }

  document.addEventListener('click', function (event) {
    var btn = event.target instanceof Element ? event.target.closest('[data-ao-boost-add]') : null;
    if (!btn || btn.disabled) return;
    event.preventDefault();
    var card = btn.closest('[data-ao-boost-card]');
    var wrap = btn.closest('[data-ao-boost]');
    var select = card && card.querySelector('[data-ao-boost-variant]');
    var err = wrap && wrap.querySelector('[data-ao-boost-error]');
    var id = select ? Number(select.value) : 0;
    if (!id) return;
    if (err) { err.hidden = true; err.textContent = ''; }
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Pridávam…';

    fetch(base + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(Object.assign({ items: [{ id: id, quantity: 1 }] }, sectionData()))
    })
      .then(function (res) { if (!res.ok) throw new Error('add-' + res.status); return res.json(); })
      .then(function (added) {
        clarityEvent('cart_boost_add');
        return fetch(base + '/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart || added,
                data: { source: 'ao-cart-boost', itemCount: cart ? Number(cart.item_count) || 0 : 0, sections: (added && added.sections) || undefined }
              }
            }));
            btn.textContent = 'Pridané ✓';
          });
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = original;
        if (err) { err.textContent = 'Tričko sa nepodarilo pridať. Skús to znova alebo ho pridaj z jeho stránky.'; err.hidden = false; }
      });
  });

  /* V299: mixér nálepiek musí bežať aj v bočnom košíku, ktorý sa prekresľuje
     (vložený <script> sa po prekreslení nespustí). Načítame ho globálne. */
  function loadStickerBundle() {
    if (window.__aoStickerBundleV299 || document.querySelector('script[data-ao-sb-loader]')) return;
    var me = document.querySelector('script[src*="ao-cart-v298.js"]');
    if (!me) return;
    var src = me.getAttribute('src').replace('ao-cart-v298.js', 'ao-sticker-bundle.js');
    var css = src.replace('ao-sticker-bundle.js', 'ao-sticker-bundle.css');
    if (!document.querySelector('link[href*="ao-sticker-bundle.css"]')) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = css;
      document.head.appendChild(link);
    }
    var s = document.createElement('script');
    s.src = src;
    s.defer = true;
    s.setAttribute('data-ao-sb-loader', 'true');
    document.head.appendChild(s);
  }

  function boot() {
    loadStickerBundle();
    observe();
    paint();
    if (document.querySelector('.ao-cart-page')) clarityEvent('cart_view', true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
